module.exports = __webpack_public_path__ + "img/dd-logo-kia.f3f09c39.png";